var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassionate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 539.22826,
    height: 727.77805,
    viewBox: "0 0 539.22826 727.77805",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M869.61413,259.05823h-3.99878V149.51289A63.40184,63.40184,0,0,0,802.21356,86.111H570.12683a63.40185,63.40185,0,0,0-63.402,63.40172V750.48711A63.40186,63.40186,0,0,0,570.12664,813.889H802.21325a63.40186,63.40186,0,0,0,63.402-63.40167V337.03447h3.99884Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M804.7716,102.606h-30.295a22.49484,22.49484,0,0,1-20.82715,30.99052H620.69a22.4948,22.4948,0,0,1-20.82715-30.99056H571.56726a47.34781,47.34781,0,0,0-47.34784,47.34774V750.04625a47.34781,47.34781,0,0,0,47.34778,47.34784H804.7716a47.3478,47.3478,0,0,0,47.34784-47.34778h0V149.9537A47.34776,47.34776,0,0,0,804.7716,102.606Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 223.5001,
    y: 134.48811,
    width: 268.56693,
    height: 458.80184,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M463.69024,318.08282c12.31092,10.25938-12.31092,42.17755-12.31092,42.17755s58.47683,2.2799,53.86023,2.2799-8.46376-48.44727-8.46376-48.44727S451.37932,307.82344,463.69024,318.08282Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M439.91476,447.91443l53,19,29,12s19,52,28,75-20,60-20,60,3,11,0,16a54.36,54.36,0,0,0-4,8c-1,2-12,1-24,0s-1-20-1-20,10-40,11-41c.9339-.9339,3.61212-7.973.704-10.5285a25.95,25.95,0,0,1-6.53687-8.12989,30.09051,30.09051,0,0,0-5.16717-7.34164s-31.69458-46.74072-47.34729-57.37036-52,2-52,2,17.34729,26.37036,17.34729,32.37036,1,9,4,11,2,6,2,10,3,12,8,16,6,8,5,16-28,4-28,4l-13-25s-20-32-33-66c-6.5-17,.25-28.5,8.625-35.75A41.39094,41.39094,0,0,1,401.56008,448.4l47.00739,2.14408-33.65271-9.62963Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M614.91476,358.91441l57-26s20-34,8-38-22,30-22,30l-41,8Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.91476,376.91441s-29,26-30,29-19,11-27-3,18-13,18-13l18-23Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M359.56747,361.544l31,23,51-18c-9.47913,29.67829-2.05243,61.10947-33.18818,79.31473l118,40c-10.44354-42.04852,6.04987-76.85827,20.18818-119.31473,22.39477-11.54092,50.484-8.8113,81,0v-41l-124,7-19.18815,10.31472L461.56747,336.544C428.54586,331.19057,387.289,342.89006,359.56747,361.544Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M435.91476,579.9144c3,2,8,21,9,28s-8,10-13,11-4,4-7,7-14,4-29,1,7-22,9-23,8-24,8-24S432.91476,577.9144,435.91476,579.9144Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M518.91482,634.9144l8,21,7.56408,11.34613a25.69633,25.69633,0,0,1,3.63166,20.90967c-1.27393,4.68853-3.91455,9.1192-9.1958,10.7442-13,4-21-21-21-21s-7-14-12-27,4-20,4-20Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150.17537,
    cy: 220.66222,
    r: 23.99585,
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M507.76288,300.84323a22.82668,22.82668,0,0,0-1.54793-18.547c-3.08238-5.46637-9.01834-10.59053-20.43009-10.87955-24.89836-.6306-35.68764,18.14244-34.28485,23.64742s6.42167,18.60263,6.42167,18.60263-3.11229-12.61195,3.1123-13.87315,30.34488-6.306,37.34754-.6306a14.2327,14.2327,0,0,1,5.44652,13.24256Z",
    transform: "translate(-330.38587 -86.11098)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.1816,
    cy: 651.74778,
    r: 26,
    fill: "#e6e6e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassionate);
export default __webpack_public_path__ + "static/media/passionate.0a2692fd2430f6dfdf7bcb7037d2856a.svg";
export { ForwardRef as ReactComponent };